import { isProd, isTestnet } from '@bfe/by-env';
const reg = /^(.*?\.){0,}(.*?)\.([\w-]{1,}?)\.(com|cn|io|org|net|nl|hk|ae)/;
const match = reg.exec(window.location.host);
const [, , m2, m4] = match || [];
export const domain = m4;
export const isMainNet = isProd;
export const isTestNet = isTestnet;
export const isLocalNet =
  location.origin.match(/:\d+/i) &&
  Number((location.origin.match(/\d+/i) as any)[0]);
export const isTest = m2 && m2.indexOf('-test-') > -1;

export const getDomainsUrl = () => {
  if (isLocalNet) {
    return 'bytick.com, bybit-cn.com';
  } else if (isTestNet) {
    return 'bybit-cn.com';
  } else if (isMainNet) {
    return 'bycbe.com, bynbc.com, byapis.com';
  } else {
    return 'bytick.com, bybit-cn.com';
  }
};
